export default class {
  static systemExpirationCheck (next) {
    if (window.bookero && window.bookero.getPackageExpirationData()) {
      let expirationData = window.bookero.getPackageExpirationData();
      let expirationDays = expirationData.expires_days;

      if (expirationDays >= 0) {
        next();
        return;
      } else if (window.bookero.userHasParent()) {
        window.bookero.showExpirationMessage();
        next('/billing/');
        return;
      } else {
        next('/billing/');
        return;
      }
    }

    next('/dashboard/');
  }

  static permissionsCheck (permissionName, next) {
    if (!window.bookero || !window.bookero.permissionsAvailable()) {
      next();
      return;
    }

    if (typeof permissionName === 'string') {
      if (window.bookero && window.bookero.hasPermissions(permissionName)) {
        next();
        return;
      }
    } else {
      for (let i = 0; i < permissionName.length; i++) {
        if (window.bookero && window.bookero.hasPermissions(permissionName[i])) {
          next();
          return;
        }
      }
    }

    next('no-permissions');
  }

  static allPermissionsCheck (permissionNames, next) {
    if (!window.bookero || !window.bookero.permissionsAvailable()) {
      next();
      return;
    }

    for (let i = 0; i < permissionNames.length; i++) {
      if (!window.bookero.hasPermissions(permissionNames[i])) {
        next('no-permissions');
        return;
      }
    }

    next();
  }

  static userIsWorkerOrReceptionist (next) {
    if (window.bookero && !window.bookero.userHasId()) {
      next();
      return;
    }

    if (window.bookero && (window.bookero.userIsWorker() || window.bookero.userIsReceptionist())) {
      next();
      return;
    }

    next('no-permissions');
  }
}



// WEBPACK FOOTER //
// ./src/router/utils.js